import React, { useEffect, useState } from "react";
import styles from "./CookieConsentBanner.module.css";

const CookieConsentBanner = ({ onAccept }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem("cookie_consent");
        if (!consent) setVisible(true);
    }, []);

    const handleAccept = () => {
        localStorage.setItem("cookie_consent", "true");
        setVisible(false);
        onAccept();
    };

    if (!visible) return null;

    return (
        <>
            <div className="container-custom">
                <div className={styles.cookieBanner}>
                    <div className={styles.content}>
                        <div className={styles.text}>
                            Мы используем cookie-файлы для корректной работы сайта и анализа посещаемости.{" "}
                            <a href="/privacy">Подробнее</a>
                        </div>
                        <button
                            className={styles.button}
                            onClick={handleAccept}
                        >
                            Согласен
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CookieConsentBanner;
